import mock from './mock'
import './auth'

mock.onAny().passThrough()
